import { createStyles } from "@mantine/core";

export const useStyle = createStyles(() => ({
  divider: {
    marginBottom: "40px !important",
  },
}));
